<template>
  <!-- <baidu-map id="map1Box" :center="center" :zoom="zoom" @ready="handler"></baidu-map>  2d百度地图  -->
  <div id="map1Box"></div>

</template>

<script>
export default {
  name: 'Map1',
  props:['load','mapCenter','zoom','maxzoom','minzoom','islimit'], //地图的变量名称
  data () {
    return {
      center: {lng: '', lat: ''}
    }
  },

  mounted:function(){
    this.initBaidu3DMap()
    // return
    // this.center.lng = this.mapCenter[0], 
    // this.center.lat = this.mapCenter[0]
    const that = this;
    // let timer = setInterval(function(){
        // window.map1 = new BMap.Map('map1Box')
        // var point = new BMap.Point(that.mapCenter[0], that.mapCenter[0])
        // window.map1.centerAndZoom(point, that.zoom)
    //   if(!window.mapabcgl){
    //     return
    //   }
    //   mapabcgl.accessToken = window.CONFIG.accessToken;
    //   window.map1 = new mapabcgl.Map({
    //       container:'map1Box',
    //       style: window.CONFIG.mapabcglStyle,
    //       zoom: that.zoom,
    //       maxZoom: that.maxzoom,
    //       minZoom: that.minzoom,
    //       center: [Number(that.mapCenter[0]),Number(that.mapCenter[1])],
    //       preserveDrawingBuffer: true
    //   });
    //   clearInterval(timer)
    // },20)
    let timer = setInterval(()=> {
      if(!window.BMap){
        return
      }
      clearInterval(timer)
      window.map1.addEventListener('tilesloaded', this.mapLoad)
    }, 20)
    
  },
  methods:{
    mapLoad(){
      const that = this;
      if(that.islimit){
      }else{
        that.limitView();
      }
      that.load();
      window.map1.removeEventListener('tilesloaded', this.mapLoad)
    },
    initBaidu3DMap(){
      window.map1 = new BMap.Map("map1Box",{
        minZoom: this.minzoom,
        maxZoom: this.maxzoom,
        enableWheelZoom: true
      })
      let point = new BMap.Point(this.mapCenter[0], this.mapCenter[1])
      window.map1.centerAndZoom(point, this.zoom)
      // window.map1.enableScrollWheelZoom(true)
      // window.map1.setMapStyle({
      //   style: 'midnight'
      // })
    },
    // handler ({BMap, map}) { //2d百度地图
    //   window.map1 = map
    //   var point = new BMap.Point(this.mapCenter[0], this.mapCenter[1])
    //   window.map1.centerAndZoom(point, this.zoom)
    //   window.map1.enableScrollWheelZoom(true)
    // },
    limitView:function(){ 
      // 限制地图视野
      // window.map1.setMaxBounds(window.map1.getBounds())
      let that = this
      let b = window.map1.getBounds()
      let bound = new BMap.Bounds(new BMap.Point(b._sw.lng, b._sw.lat), new BMap.Point(b._ne.lng, b._ne.lat));
      window.map1.addEventListener("dragend", function(type, target) {
        if (bound.containsBounds(window.map1.getBounds())) {
          return;
        }else{
          let timer = setTimeout(function () {
            // window.map1.panTo(new BMap.Point(that.mapCenter[0], that.mapCenter[1]));
            clearTimeout(timer)
          }, 100);
        }
      })
     // try {	
      //   // BMapLib.AreaRestriction.setBounds(window.map1, bound);
      // } catch (e) {
      //   alert(e);
      // }
    }
  },
  beforeDestroy() {       
    window.map1 = null
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#map1Box{
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1;
}
</style>
